import { createI18n } from 'vue-i18n'

const messages = {
  es: {
    nav: {
      home: 'Inicio',
      login: 'Iniciar Sesión',
      logout: 'Cerrar Sesión',
      muestra: 'Muestra'
    },
    login: {
      title: 'Bienvenido de nuevo',
      subtitle: 'Por favor inicie sesión para continuar',
      username: 'Usuario',
      password: 'Contraseña',
      signIn: 'Iniciar Sesión',
      createAccount: 'Crear Cuenta',
      createAccountSubtitle: 'Únete para comenzar a procesar tus datos',
      forgotPassword: '¿Olvidaste tu contraseña?',
      resetPassword: 'Restablecer Contraseña',
      resetPasswordSubtitle: 'Ingrese su correo para restablecer su contraseña',
      usernamePlaceholder: 'Ingrese su Usuario',
      passwordPlaceholder: 'Ingrese su Contraseña'
    },
    redlie: {
      title: 'Índice de disponibilidad léxica - Redlie',
      description: 'Bienvenido a REDLIE, nuestro software libre para cálculo IDL. Por favor, atiende las siguientes indicaciones.',
      subtitle: 'Para poder procesar tus datos, organiza tu base de datos en un documento con los siguientes requerimientos:',
      challenges: {
        title: 'Conflictos',
        item1: 'El Archivo debe ser un documento de texto plano (.csv). Separado por punto y coma (;).',
        item2: 'Debe contener los siguientes campos: NI;CI;SEXO;EDAD;VOCABLOS',
        item3: 'Los valores de los campos deben ser los siguientes: 1;3;2;23;perro,gato,ratón,.....'
      }
    },
    home: {
      welcome: 'Bienvenido a Redlie',
      uploadTitle: 'Subir Datos',
      processTitle: 'Procesar Resultados',
      viewTitle: 'Ver Estadísticas'
    },
    common: {
      language: 'Idioma',
      submit: 'Enviar',
      cancel: 'Cancelar',
      translatePage: 'Traducir esta página'
    }
  }
}

export const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('userLanguage') || 'es',
  fallbackLocale: 'es',
  messages
})
